import { deepMerge } from 'js/utils/Utils'
import { lerp, roundEx } from 'js/utils/Maths'
import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'slotAnimation',
  $names: {
    slot: '[data-slot]',
    item: '[data-slot-i]',
  },
  dataNames: {
    timeFactor: 'timeFactor',
    scrollFactor: 'scrollFactor',
    offset: 'offset',
  },
  itemCloneCount: 6,
  itemCloneCountMobile: 7,
}

export default class SlotAnimation {
  $contentRoot = document
  $slots = []
  slotInfo = []
  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    if (Common.detection.isMobileLayout) {
      this.itemCloneCount = this.itemCloneCountMobile
    }

    this._set$()
    this.initInfo()
    this._setItemHeight()
    this._addHandlers()
  }

  destroy() {
    this._removeHandlers()
  }

  _set$() {
    this.$slots = this.$contentRoot.querySelectorAll(this.$names.slot)
  }

  _addHandlers() {
    if (Common.raf) {
      Common.raf.addHandler(() => {
        this.onRaf()
      }, this.instanceName)
    }

    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, this.instanceName)
    }
  }

  _removeHandlers() {
    if (Common.raf) {
      Common.raf.removeHandler(this.instanceName)
    }

    if (Common.resize) {
      Common.resize.removeHandler(this.instanceName)
    }
  }

  initInfo() {
    this.$slots.forEach(($slot, i) => {
      const $item = $slot.querySelector(this.$names.item)
      const clonedItems = []
      for (let j = 0; j < this.itemCloneCount; j++) {
        clonedItems.push($item.cloneNode(true))
      }

      const data = $slot.dataset

      $slot.innerHTML = ''
      clonedItems.forEach(($clone) => {
        $slot.appendChild($clone)
      })
      this.slotInfo[i] = {
        items: clonedItems,
        itemHeight: $item?.offsetHeight || 0,
        currentPosition: 0,
        targetPosition: 0,
        speed: parseFloat(data[this.dataNames.timeFactor]) || 1,
        time: 0,
        scroll: 0,
        scrollLerp: 0,
        scrollFactor: parseFloat(data[this.dataNames.scrollFactor]) || 0.5,
        offset: parseFloat(data[this.dataNames.offset]) || 0,
        scrollLerpFactor: 0.25,
        useTimeAnimation: true,
        useScrollAnimation: true,
      }
    })
  }

  _setItemHeight() {
    this.slotInfo.forEach((info, i) => {
      const $slot = this.$slots[i]
      const $item = $slot.querySelector(this.$names.item)

      if (Common.detection.isMobileLayout) {
        info.itemHeight = $item?.getBoundingClientRect()?.width || 0
      } else {
        info.itemHeight = $item?.getBoundingClientRect()?.height || 0
      }
      info.itemHeight = roundEx(info.itemHeight, 1000)

      if (Common.detection.isMobileLayout) {
        $item.style.marginLeft = `${info.itemHeight * -1}px`
      } else {
        $item.style.marginTop = `${info.itemHeight * -1}px`
      }
    })
  }

  onResize() {
    this._setItemHeight()
  }

  onRaf() {
    this.slotInfo.forEach((info, i) => {
      const $slot = this.$slots[i]
      if (info.useTimeAnimation) {
        info.time += info.speed
      }
      if (info.useScrollAnimation && !Common.detection.isMobileLayout) {
        info.scroll = Common.scroll.currentScroll
        info.scrollLerp = lerp(info.scrollLerp, info.scroll, info.scrollLerpFactor / Common.raf.fpsMultiplier)
        info.scrollLerp = roundEx(info.scrollLerp, 1000)
        info.targetPosition = info.scrollLerp * info.scrollFactor
      }
      info.currentPosition = info.targetPosition + info.time - info.itemHeight * 0.333 * i + info.offset * info.itemHeight
      if (info.itemHeight > 0) {
        const translate = (info.currentPosition % info.itemHeight) * -1

        if (Common.detection.isMobileLayout) {
          $slot.style.transform = `translateX(${translate}px)`
        } else {
          $slot.style.transform = `translateY(${translate}px)`
        }
      }
    })
  }
}